import React from 'react';
import { TextField, Typography, Button } from '@material-ui/core';
import jwt_decode from 'jwt-decode';
import { useSnackbar } from 'notistack';
import { Icons } from '../../components';
import { updatePasswordMobile } from '../../services';

const checkToken = (token: any) => {
  try {
    const decoded: any = jwt_decode(token);
    if (Date.now() >= decoded.exp * 1000) {
      return false;
    }

    return decoded;
  } catch (err) {
    return false;
  }
};

const ResetPassword = (props: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const [state, setState] = React.useState({
    password: '',
    confirmPassword: '',
    errorMessage: '',
  });
  const token = props.match.params.token;
  const validToken = checkToken(token);
  if (!validToken) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 32,
        }}
      >
        <Typography
          variant='h5'
          color='textPrimary'
          style={{ fontWeight: 300 }}
        >
          Token Not Valid
        </Typography>
      </div>
    );
  }

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (state.password !== state.confirmPassword) {
      setState({
        ...state,
        errorMessage: "Password confirmation doesn't match the password",
      });
      return;
    }
    const updatePw = await updatePasswordMobile(token, {
      password: state.password,
    });
    if (updatePw.status === 'error') {
      enqueueSnackbar(updatePw.message, {
        variant: 'error',
      });
      return;
    }
    setState({
      password: '',
      confirmPassword: '',
      errorMessage: '',
    });
    enqueueSnackbar('successfully reset password', {
      variant: 'success',
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div style={{ padding: '32px 0' }}>
        <Icons.IconLogo />
      </div>
      <Typography variant='h5' color='textPrimary' style={{ fontWeight: 300 }}>
        Change password For
      </Typography>
      <Typography variant='h5' color='textPrimary' style={{ fontWeight: 300 }}>
        {validToken.email}
      </Typography>
      <form
        onSubmit={handleSubmit}
        style={{
          width: '100%',
          maxWidth: 350,
          marginTop: 16,
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          id='password'
          type='password'
          name='password'
          label='Password'
          variant='outlined'
          onChange={handleChange}
          value={state.password}
          required
          style={{ marginBottom: 16 }}
        />
        <TextField
          id='confirm-password'
          type='password'
          name='confirmPassword'
          label='Confirm Password'
          variant='outlined'
          onChange={handleChange}
          value={state.confirmPassword}
          required
        />
        <Typography
          variant='overline'
          color='error'
          style={{ marginTop: 12, textTransform: 'lowercase', lineHeight: 1.2 }}
        >
          {state.errorMessage}
        </Typography>
        <Button
          type='submit'
          variant='contained'
          color='primary'
          style={{ marginTop: 24, marginBottom: 32 }}
        >
          Change Password
        </Button>
        <Typography
          variant='subtitle2'
          color='textSecondary'
          style={{ textAlign: 'center' }}
        >
          &copy; Copyright 2021. Jakarta TollRoad Development All Rights
          Reserved.
        </Typography>
      </form>
    </div>
  );
};

export default ResetPassword;
